import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";


const IdolTimerWrapper = () => {
    const [signoutTime, setSignoutTime] = useState(2000000);
    let logoutTimeout: NodeJS.Timeout;
    const navigate = useNavigate();

    const logout = () => {
        console.log('You have been lo b gged out');
        navigate("/");
    }

    const setTimeouts = () => {
        logoutTimeout = setTimeout(logout, signoutTime);
    };

    const clearTimeouts = () => {
        if (logoutTimeout) clearTimeout(logoutTimeout);
    };

    useEffect(() => {

        const events = [
            'load',
            'mousemove',
            'mousedown',
            'click',
            'scroll',
            'keypress'
        ];

        const resetTimeout = () => {
            clearTimeouts();
            setTimeouts();
        };

        for (let i in events) {
            window.addEventListener(events[i], resetTimeout);
        }

        setTimeouts();
        return () => {
            for (let i in events) {
                window.removeEventListener(events[i], resetTimeout);
                clearTimeouts();
            }
        }
    }, []);


    return <div></div>
}
export {
    IdolTimerWrapper
};

